









import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system";
import { IRollSelectBehavior, IRollOption } from "../../../../domain/format/objects";
import { CommonComponentsContainer } from "../../../../../formatEditor/components/format/editors/contents";

@Component
export default class RollSelectBehaviorEditor extends Mixins(ModelEditableMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IRollSelectBehavior) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IRollSelectBehavior) => T, defaultValue: T) => T;

  @Prop()
  commonComponents: CommonComponentsContainer;

  get options(): IRollOption[] {
    return this.readPropertyOrDefault(s => s.options, []);
  }

  set options(value: IRollOption[]) {
    this.writePropertyWhenValid(s => s.options = value);
  }

  async showRollSelectOptionEditDialog() {
    const dialog = this.commonComponents.getDialogs().getRollOptionEditDialog();
    const rollOptions = await dialog.show(this.options);
    if (!rollOptions) { return; }
    this.options = rollOptions;
  }
}
